<template>
    <router-view />
</template>

<script>
export default {
    name: "HomeLayoutView",
};
</script>

